import React from "react"
import Yarl from "yet-another-react-lightbox"
import Fullscreen from "yet-another-react-lightbox/dist/plugins/fullscreen"
import Zoom from "yet-another-react-lightbox/dist/plugins/zoom"
import "yet-another-react-lightbox/dist/styles.css"

const LightboxYarl = ({
  slides,
  index,
  setIndex,
  isFinite,
  isOpen,
  onClose,
}) => {
  if (!(slides?.length > 0)) return null

  return (
    <Yarl
      plugins={[Fullscreen, Zoom]}
      index={isFinite ? 0 : index}
      carousel={{
        preload: 2,
        finite: isFinite,
      }}
      controller={{
        closeOnBackdropClick: true,
      }}
      slides={isFinite ? slides.slice(0, 1) : slides}
      render={
        isFinite
          ? {
              buttonPrev: () => null,
              buttonNext: () => null,
            }
          : undefined
      }
      open={isOpen}
      close={typeof onClose === "function" ? onClose : undefined}
      on={{
        view: ({ index }) => {
          if (typeof setIndex === "function") setIndex(index)
        },
      }}
    />
  )
}

export default LightboxYarl
